import React from 'react';
import PropTypes from 'prop-types';

const IconConvert = ({ width = '16px', height = '16px', color = 'currentColor' }) => {
    return (
        <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M14.5 4.5H1.5M14.5 4.5L11.5 1.5M14.5 4.5L11.5 7.5' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M1.5 11.5H14.5M1.5 11.5L4.5 8.5M1.5 11.5L4.5 14.5' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    );
};

IconConvert.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string
};

export default IconConvert;
